import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import AppBar from "./components/AppBar";
import LandingPage from "./components/LandingPage";
import DealerList from "./components/DealerList";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import Dealer from "./components/Dealer";
import footerStyles from "./footer.module.css";
import List from "@material-ui/icons/List";
import Undo from "@material-ui/icons/Undo";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import GoogleAnalytics from "./GoogleAnalytics";

function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}

const Footer = () => (
	<div className={footerStyles.footer}>
		<div>
			Made with &lt;3 By{" "}
			<a
				href="https://twitter.com/KeytarFox"
				target="_blank"
				rel="noopener noreferrer"
			>
				Keys
			</a>
		</div>
		<div>Banner table images provided by TaniDaReal & Sockmuffin</div>
	</div>
);

export default function App() {
	const menuItems = (
		<>
			<Link
				to={process.env.REACT_APP_ROOT_URL}
				style={{ textDecoration: "none", color: "initial" }}
			>
				<ListItem button>
					<ListItemIcon>
						<InboxIcon />
					</ListItemIcon>
					<ListItemText primary="Home" />
				</ListItem>
			</Link>
			<Link
				to={`${process.env.REACT_APP_ROOT_URL}/dealers-list`}
				style={{ textDecoration: "none", color: "initial" }}
			>
				<ListItem button>
					<ListItemIcon>
						<List />
					</ListItemIcon>
					<ListItemText primary="Dealer list" />
				</ListItem>
			</Link>
			<a
				href="https://2020.confuzzled.org.uk/"
				style={{ textDecoration: "none", color: "initial" }}
			>
				<ListItem button>
					<ListItemIcon>
						<Undo />
					</ListItemIcon>
					<ListItemText primary="Main site" />
				</ListItem>
			</a>
		</>
	);
	return (
		<Router>
			<ScrollToTop />
			<AppBar menuItems={menuItems}>
				<Switch>
					<Route
						path={`${process.env.REACT_APP_ROOT_URL}/dealers-list`}
						component={DealerList}
					/>
					<Route
						path={`${process.env.REACT_APP_ROOT_URL}/dealer/:id`}
						component={Dealer}
					/>
					<Route
						path={`${process.env.REACT_APP_ROOT_URL}/`}
						component={LandingPage}
					/>
				</Switch>
				<Switch>
					<Route path={`${process.env.REACT_APP_ROOT_URL}/`} exact />
					<Route component={Footer} />
				</Switch>
				<GoogleAnalytics />
			</AppBar>
		</Router>
	);
}
